
export class ResetPassword   {
	public password: string;
	public confirmPassword: string;
	public code: string;
}